module.exports = __webpack_public_path__ + "img/2@2x.e6d29fc9.png";